<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import LoadingSpinner from "$app/components/LoadingSpinner.svelte"
  import InfiniteScroll from "$app/components/InfiniteScroll.svelte"

  const API_KEY = "E6fVm7Gk68GY2dJdmw2eaRBCDFHlObjs"
  const LIMIT = 35

  let { onimage }: { onimage: (data: any) => void } = $props()

  let loading = $state(false)
  let openModal = $state(false)
  let search = $state("")

  let result: giphyResponse = {
    data: [],
    pagination: {
      total_count: 0,
      count: 0,
      offset: 0
    }
  }

  let data = $state([])
  let offset = $state(0)
  let searching = $state(false)
  let lastSearch = $state("")

  async function searchData(url: string): Promise<giphyResponse> {
    const resp = await fetch(url)
    const giphy: giphyResponse = await resp.json()

    return giphy
  }

  async function loadTrending(): Promise<void> {
    if (offset == 0) {
      loading = true
    }

    try {
      const url = `https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=${LIMIT}&offset=${offset}`
      result = await searchData(url)
      if (data.length > 0) {
        data = [...data, ...result?.data]
      } else {
        data = result.data
      }
    } catch (e) {
      console.error(e)
    } finally {
      loading = false
    }
  }

  async function searchGifs(): Promise<void> {
    if (!searching || lastSearch != search) {
      searching = true
      offset = 0
      data = []
    }
    if (search.length == 0) {
      offset = 0
      data = []
      loadTrending()
    }
    if (offset === 0) {
      loading = true
    }

    try {
      const url = `https://api.giphy.com/v1/gifs/search?api_key=${API_KEY}&q=${search}&limit=${LIMIT}&offset=${offset}&rating=G&lang=en`

      result = await searchData(url)
      lastSearch = search
      if (data.length > 0) {
        data = [...data, ...result?.data]
      } else {
        data = result.data
      }
    } catch (e) {
      console.error(e)
    } finally {
      loading = false
    }
  }

  function triggerSearch(evt) {
    if (evt.keyCode == 13) {
      searchGifs()
    }
  }

  function selectImg(e: MouseEvent, img: giphyType): void {
    openModal = false
    if (!(e.target instanceof HTMLImageElement)) return
    onimage({
      image: img,
      width: e.target.naturalWidth,
      height: e.target.naturalHeight
    })
  }

  $effect(() => {
    if (openModal) {
      offset = 0
      loadTrending()
    }
  })
</script>

<button
  type="button"
  onclick={() => (openModal = !openModal)}
  class="relative -m-2 inline-flex h-10 w-10 items-center justify-center text-gray-400 hover:text-gray-500"
  style="font-size:1.2rem"
>
  GIF
</button>

<Modal
  open={openModal}
  hasBackdrop={false}
  class="border-2 border-gray-200 w-128"
  closeOnOuterClick={true}
  onclose={() => {
    openModal = false
    search = ""
    result.data = []
  }}
>
  <div id="cont" class="p-2 pb-6">
    <div>
      <div class="mt-2 flex rounded-md shadow-sm">
        <div class="relative flex flex-grow items-stretch focus-within:z-10">
          <div class="relative flex flex-grow items-stretch focus-within:z-10">
            <input
              type="text"
              bind:value={search}
              placeholder="Find images"
              class="!mt-0 block w-full !rounded-none !rounded-l-md !border-0 !py-1.5 !px-2 text-gray-900 !ring-1 !ring-inset ring-gray-300 placeholder:text-gray-400 !focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              onkeydown={triggerSearch}
            />
          </div>
          <button
            type="button"
            onclick={searchGifs}
            class="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          >
            Search
          </button>
        </div>
      </div>

      <div id="results" class="overflow-y-auto w-[450px] mt-2">
        {#if !loading}
          <div class="columns-3 gap-2">
            {#each data as res}
              <button onclick={(e) => selectImg(e, res)} type="button">
                <img
                  src={res.images.original.url}
                  alt={res.title}
                  class="cursor-pointer mb-2 border-2 border-white hover:border-blue-400"
                />
              </button>
            {/each}
          </div>
          <InfiniteScroll
            hasMore={true}
            threshold={10}
            onloadmore={() => {
              offset += LIMIT
              if (searching) {
                searchGifs()
              } else {
                loadTrending()
              }
            }}
          />
        {:else}
          <LoadingSpinner />
        {/if}
      </div>
    </div>
  </div></Modal
>

<style>
  :root {
    --height: 360px;
  }
  #cont {
    max-width: 600px;
    height: var(--height);
  }

  #results {
    height: calc(var(--height) - 54px);
  }
</style>
